import CrossReferencedField from "../CrossReferencedField";

export default class CrossReferencedHeatingField extends CrossReferencedField {

    constructor(name, step, heatingIndex) {
        super(name, step, 'heating' + heatingIndex)
    }
}
